import NewBillGeneral from "./NewBillGeneral";

export default NewBillGeneral;
